<template>
  <router-view></router-view>
</template>

<script>
// import '../css/main.css'
export default {

}
</script>

<style scoped>
/* @import url(../css/main.css); */
</style>
